import React from 'react';
import {Timeline, TimelineEvent} from 'react-event-timeline';
import useMediaQuery from '@mui/material/useMediaQuery';

const Education = () => {
  const mediaMatch = useMediaQuery('(min-width:720px)');
  return (
    <div style={{display:'flex',flexDirection:'column', gap:'15px', padding:'5%'}}>
      <div style={{fontSize:'24px',textAlign:'center',marginBottom:3}}>EDUCATION</div>
      <div style={{
        display:mediaMatch?'flex':"block",
        gap:'30px',
      }}>
        <div style={{width:'50vw',fontSize:24,color:"black"}}>
          <Timeline>
          <TimelineEvent
            title=""
            createdAt="Jan 2022 - Dec 2022" 
            container="card"
            cardHeaderStyle={{
              backgroundColor:'#1976d2',
              color:'white'
            }}
          ><b>Masai School</b><br/>Student - Web development [MERN] Full-Time</TimelineEvent>
          <TimelineEvent
            title=""
            createdAt="Aug 2017 - Nov 2021"
            container="card"
            cardHeaderStyle={{
              backgroundColor:'#1976d2',
              color:'white'
            }}
          ><b>Lovely Professional University</b><br/>B.tech Graduate</TimelineEvent>
        </Timeline>
        </div>
        <div className='img-scale' style={{width:"50vw"}}><img src='./college1.png' width={mediaMatch?'480px':'290px'} alt="" style={{paddingTop:'40px'}}/></div>
      </div>
    </div>
  )
}

export default Education